import { createAction } from "redux-act";
import { normalize } from "normalizr";
import axios from "axios";
import md5 from "md5";
import { toast } from "react-toastify";
import { increaseLoading, decreaseLoading } from "../app/actions";

export const createAsyncAction = action => {
  return {
    pending: createAction(action + "Pending"),
    success: createAction(action + "Success"),
    error: createAction(action + "Error"),
    finally: createAction(action + "Finally")
  };
};

const hashFromObj = obj => {
  return md5(JSON.stringify(obj));
};

let pendingRequests = [];
let toastId = "";
let toastId500 = "";
// Wrapper for async request using axios. It handles dispatching actions through a lifetime of the request.
//
// method: http method,
// url: request url,
// action: object of functions created by createAsyncAction,
// dispatch: required for dispatching actions,
// schema(optional): if provided, response will be normalized with given schema,
// options(optional): request options passed directly to axios,
// view(optional): name of the view for the request,
// errorHangler(optional): hook for handling errors
export const request = async (
  method,
  url,
  options,
  { view = "default", action, schema, dispatch, errorHandler }
) => {
  const hash = hashFromObj({ method, url, options });
  //if (method === "get") {
  //if (pendingRequests[hash]) {
  //return;
  //}
  //}
  pendingRequests[hash] = hash;
  dispatch(increaseLoading());

  dispatch(action.pending());
  try {
    const { data, status } = await axios({
      method,
      url,
      ...options
    });

    let body = data;

    if (schema) {
      body = normalize(data, schema);
    }

    dispatch(action.success({ data: body, view }));
    dispatch(action.finally());
    dispatch(decreaseLoading());
    pendingRequests[hash] = null;

    return { data, status };
  } catch (e) {
    dispatch(action.finally());
    dispatch(decreaseLoading());
    pendingRequests[hash] = null;

    if (!e.response) {
      if (!toast.isActive(toastId)) {
        toastId = toast.error(
          "Brak połączenia! Sprawdź czy jesteś połączony z internetem i spróbuj ponownie. W razie dalszych problemów skontaktuj się z nami: support@opiekujsie.pl",
          { autoClose: 12000 }
        );
      }
    }

    if (e.response && e.response.status === 500) {
      if (!toast.isActive(toastId500)) {
        toastId500 = toast.error(
          "Błąd serwera! Jeśli błąd będzie się powtarzał, skontaktuj się z nami: support@opiekujsie.pl",
          { autoClose: 12000 }
        );
      }
    }

    if (errorHandler) {
      errorHandler(e);
    } else {
      throw e;
    }
  }
};

export const replacePlaceholders = (link, placeholders) => {
  Object.keys(placeholders).map(placeholder => {
    link = link.replace(`:${placeholder}`, placeholders[placeholder]);
    return link;
  });

  return link;
};



// WEBPACK FOOTER //
// ./src/lib/utils.js